import { styled } from '@openeducation/oe-it-themes';
import { MotiView } from 'moti';
import React from 'react';
import { Platform, Pressable } from 'react-native';

import { flex, width as widthUtil } from '../../style-utils';

type SideMenuOverlayProps = React.PropsWithChildren<{
  opacity?: number;
  onPress?: () => void;
}>;

export function SideMenuOverlay({
  opacity = 0.5,
  onPress,
}: SideMenuOverlayProps) {
  return (
    <Overlay
      from={{ opacity: 0 }}
      animate={{ opacity }}
      exit={{ opacity: 0 }}
      transition={{ type: 'timing', duration: 600 }}
    >
      <Pressable
        style={[flex('flex-1'), widthUtil('100%')]}
        onPress={onPress}
      />
    </Overlay>
  );
}

const Overlay = styled(MotiView)`
  position: absolute;
  bottom: 0px;
  left: 0px;
  top: 0px;
  ${Platform.OS === 'web' ? 'width: 100vw; height: 100vh;' : 'right: 0px;'}
  background-color: ${({ theme }) => theme.color.dark1};
`;
